import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAPQLHlM6cmm2zre8ja6Jw-okwtzbKCnxI",
  authDomain: "kerblet-parking-app.firebaseapp.com",
  databaseURL: "https://kerblet-parking-app.firebaseio.com",
  projectId: "kerblet-parking-app",
  storageBucket: "kerblet-parking-app.appspot.com",
  messagingSenderId: "81219996845",
  appId: "1:81219996845:web:8e6ed2e1449eb04fbbca24"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app; 